<template>
  <div class="app-textfield-with-icon">
    <FeatherIcon
      v-if="innerIconType === 'email'"
      icon="mail"
      class="app-textfield-with-icon__inner-icon app-textfield-with-icon__inner-icon--left"
    />
    <FeatherIcon
      v-if="innerIconType === 'password'"
      icon="lock"
      class="app-textfield-with-icon__inner-icon app-textfield-with-icon__inner-icon--left"
    />
    <FeatherIcon
      v-if="innerIconType === 'phoneNumber'"
      icon="phone"
      class="app-textfield-with-icon__inner-icon app-textfield-with-icon__inner-icon--left"
    />
    <BFormInput
      :value="value"
      :type="inputType"
      :state="state"
      :placeholder="placeholder"
      :disabled="disabled"
      :inputmode="inputmode"
      class="app-textfield-with-icon__input"
      :class="{
        'app-textfield-with-icon__input--with-icon': !!innerIconType,
        'app-textfield-with-icon__input--with-password-icon':
          innerIconType === 'password'
      }"
      @input="onInput"
      @blur="onBlur"
    />
    <FeatherIcon
      v-if="showPasswordToggle && !isPasswordDisplay"
      icon="eye"
      class="app-textfield-with-icon__inner-icon app-textfield-with-icon__inner-icon--right"
      @click="onClickDisplayPassword"
    />
    <FeatherIcon
      v-if="showPasswordToggle && isPasswordDisplay"
      icon="eye-off"
      class="app-textfield-with-icon__inner-icon app-textfield-with-icon__inner-icon--right"
      @click="onClickDisplayPassword"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { ValidationStateType } from "@/types/Validation";
import { getFormState } from "@/utils/validation";

@Component({
  components: {
    FeatherIcon
  }
})
export default class AppTextFieldWithIcon extends Vue {
  isPasswordDisplay = false;

  get state() {
    return getFormState(this.validationState);
  }

  get inputType() {
    // パスワード表示機能がある場合
    if (this.isPasswordDisplay) {
      return "text";
    }
    return this.type;
  }

  @Prop({
    type: String || Number,
    required: true,
    default: ""
  })
  value!: string | number;

  @Prop({
    type: String,
    default: ""
  })
  label!: string;

  @Prop({
    type: String,
    default: ""
  })
  placeholder!: string;

  @Prop({
    type: String,
    default: "text"
  })
  type!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  @Prop({
    type: String,
    default: ""
  })
  innerIconType!: "email" | "password" | "phoneNumber";

  @Prop({
    type: Boolean,
    default: false
  })
  showPasswordToggle!: boolean;

  @Prop({
    type: Object,
    default: () => ({})
  })
  validationState!: ValidationStateType;

  @Prop({
    type: String,
    default: null
  })
  inputmode!: string | null;

  onInput(v: string | number) {
    this.$emit("input", v);
  }

  onBlur(v: string | number) {
    this.$emit("blur", v);
  }

  onClickDisplayPassword() {
    this.isPasswordDisplay = !this.isPasswordDisplay;
  }
}
</script>

<style lang="scss" scoped>
.app-textfield-with-icon {
  position: relative;

  &__input {
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 8px;
    background-color: $white;
    border: 1px solid $gray-04;

    &::placeholder {
      color: $gray-04;
    }

    &:disabled {
      background-color: $gray-03;
    }

    &--with-icon {
      padding-left: 40px;
    }

    &--with-password-icon {
      padding-right: 70px;
    }
  }

  &__inner-icon {
    position: absolute;
    top: 50%;
    width: 18px;
    height: 18px;
    transform: translateY(-50%);

    &--left {
      left: 12px;
      color: $gray-05;
    }

    &--right {
      right: 12px;
      color: $mild;

      .is-valid + &,
      .is-invalid + & {
        right: 40px;
      }
    }
  }
}
</style>
